/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  BatchUploadRequestCostCenterRequestDto,
  BatchUploadReviewSuppliers2Payload,
  CostCenterBulkUpdateRequest,
  CostCenterRequest,
  CostCenterResponse,
  CsvReviewResponseCostCenterRequestDto,
  GetAllByOrganisation2Params,
  GetAllPagedByOrganisation3Params,
  GetCostCentersIdsByOrganisationWithoutPaginationParams,
  InfiniteScrollListCostCenterResponseObject,
  ManagersUpdateRequestDto,
  ManagersUpdateResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiCostCenterController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-cost-center-controller
   * @name CreateCostCenter
   * @request POST:/api/v1/cost-center
   */
  createCostCenter = (data: CostCenterRequest, params: RequestParams = {}) =>
    this.http.request<CostCenterResponse, any>({
      path: `/v1/cost-center`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createCostCenterPath = '/v1/cost-center'
  static createCostCenterMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cost-center-controller
   * @name GetById3
   * @summary Return const center by cost center id
   * @request GET:/api/v1/cost-center/{costCenterId}
   */
  getById = (costCenterId: string, params: RequestParams = {}) =>
    this.http.request<CostCenterResponse, any>({
      path: `/v1/cost-center/${costCenterId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdPath = '/v1/cost-center/${costCenterId}'
  static getByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cost-center-controller
   * @name UpdateCostCenter
   * @request POST:/api/v1/cost-center/{costCenterId}
   */
  updateCostCenter = (costCenterId: string, data: CostCenterRequest, params: RequestParams = {}) =>
    this.http.request<CostCenterResponse, any>({
      path: `/v1/cost-center/${costCenterId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateCostCenterPath = '/v1/cost-center/${costCenterId}'
  static updateCostCenterMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cost-center-controller
   * @name DeleteCostCenter
   * @request DELETE:/api/v1/cost-center/{costCenterId}
   */
  deleteCostCenter = (costCenterId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/cost-center/${costCenterId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteCostCenterPath = '/v1/cost-center/${costCenterId}'
  static deleteCostCenterMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-cost-center-controller
   * @name UpdateManagers
   * @request POST:/api/v1/cost-center/managers
   */
  updateManagers = (data: ManagersUpdateRequestDto, params: RequestParams = {}) =>
    this.http.request<ManagersUpdateResponse, any>({
      path: `/v1/cost-center/managers`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateManagersPath = '/v1/cost-center/managers'
  static updateManagersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cost-center-controller
   * @name BulkUpdateCostCenters
   * @request POST:/api/v1/cost-center/bulk-update
   */
  bulkUpdateCostCenters = (data: CostCenterBulkUpdateRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/cost-center/bulk-update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkUpdateCostCentersPath = '/v1/cost-center/bulk-update'
  static bulkUpdateCostCentersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cost-center-controller
   * @name BatchUploadCostCenters
   * @request POST:/api/v1/cost-center/batch-upload
   */
  batchUploadCostCenters = (
    data: BatchUploadRequestCostCenterRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/cost-center/batch-upload`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static batchUploadCostCentersPath = '/v1/cost-center/batch-upload'
  static batchUploadCostCentersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cost-center-controller
   * @name BatchUploadReviewSuppliers2
   * @request POST:/api/v1/cost-center/batch-upload/review
   */
  batchUploadReviewSuppliers = (
    data: BatchUploadReviewSuppliers2Payload,
    params: RequestParams = {},
  ) =>
    this.http.request<CsvReviewResponseCostCenterRequestDto, any>({
      path: `/v1/cost-center/batch-upload/review`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static batchUploadReviewSuppliersPath = '/v1/cost-center/batch-upload/review'
  static batchUploadReviewSuppliersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cost-center-controller
   * @name GetByIds2
   * @summary Receive a list of cost center ids separate by comma and returns a list of cost centers
   * @request GET:/api/v1/cost-center/{costCenterIds}
   */
  getByIds = (costCenterIds: string[], params: RequestParams = {}) =>
    this.http.request<CostCenterResponse[], any>({
      path: `/v1/cost-center/${costCenterIds}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdsPath = '/v1/cost-center/${costCenterIds}'
  static getByIdsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cost-center-controller
   * @name GetAllPagedByOrganisation3
   * @request GET:/api/v1/cost-center/paged
   */
  getAllPagedByOrganisation = (
    query: GetAllPagedByOrganisation3Params,
    params: RequestParams = {},
  ) =>
    this.http.request<InfiniteScrollListCostCenterResponseObject, any>({
      path: `/v1/cost-center/paged`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllPagedByOrganisationPath = '/v1/cost-center/paged'
  static getAllPagedByOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cost-center-controller
   * @name GetAllByOrganisation2
   * @request GET:/api/v1/cost-center/organisation
   */
  getAllByOrganisation = (query: GetAllByOrganisation2Params, params: RequestParams = {}) =>
    this.http.request<CostCenterResponse[], any>({
      path: `/v1/cost-center/organisation`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllByOrganisationPath = '/v1/cost-center/organisation'
  static getAllByOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cost-center-controller
   * @name GetCostCentersIdsByOrganisationWithoutPagination
   * @request GET:/api/v1/cost-center/organisation/all/ids
   */
  getCostCentersIdsByOrganisationWithoutPagination = (
    query: GetCostCentersIdsByOrganisationWithoutPaginationParams,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/v1/cost-center/organisation/all/ids`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getCostCentersIdsByOrganisationWithoutPaginationPath =
    '/v1/cost-center/organisation/all/ids'
  static getCostCentersIdsByOrganisationWithoutPaginationMethod = 'GET'
}
